import React from "react"
import BlogPreviewAuthorStyle from "./BlogPreviewAuthorStyle.module.styl"
import Image from "gatsby-image"
import { Link } from "gatsby"

const BlogPreviewAuthor = ({ authorName, authorEmail, author }) => {
  return (
    <div className={BlogPreviewAuthorStyle.content}>
      <div className={BlogPreviewAuthorStyle.holder}>
        <div className={BlogPreviewAuthorStyle.author_name_holder}>
          <p className={BlogPreviewAuthorStyle.title}>Автор:</p>
          <Link
            to={`/${author.slug}/`}
            className={BlogPreviewAuthorStyle.author}
          >
            {authorName}
          </Link>
        </div>
        <Image
          className={BlogPreviewAuthorStyle.image}
          fluid={author.avatar.fluid}
        />
      </div>
      <div className={BlogPreviewAuthorStyle.email_holder}>
        <p className={BlogPreviewAuthorStyle.title}>Емайл:</p>
        <p className={BlogPreviewAuthorStyle.email}>{authorEmail}</p>
      </div>
      <div className={BlogPreviewAuthorStyle.author_bio}>
        <p className={BlogPreviewAuthorStyle.for_the_author}>За автора:</p>
        {author.bio.content.map(des => {
          return des.content.map((bio, index) => {
            return (
              <p key={index} className={BlogPreviewAuthorStyle.description}>
                {bio.value}
              </p>
            )
          })
        })}
      </div>
    </div>
  )
}

export default BlogPreviewAuthor
